import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as STORAGE_BUCKET from '../../constants/storageBucket';
import defaultUser from '../../assets/defaultUser.png';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import styles from './ThreeDHomes.scss';
import ButtonBase from '@material-ui/core/ButtonBase';
import CallFurioos from '../videoCall/FurioosController';
import CancelIcon from '@material-ui/icons/Cancel';
import ClearIcon from '@material-ui/icons/Clear';
import Modal from '../layout/modal/Modal';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import UnityController from '../videoCall/UnityPage/UnityController';
import { onUnityUpdateMessage } from '../videoCall/UnityLogic/ReceiveMessage';
import { Carousel } from 'react-responsive-carousel';
import LotMatrix from '../lotMatrix/LotMatrix';
import AWSController from '../aws-component/AWSController';
import CustomButton from '../layout/customButton/CustomButton';
import getFloorplans from '../../api/FileExplorer/getFloorplans.api';
import Lightbox from 'react-image-lightbox';

function ThreeDHomes() {
	console.log('ThreeDHomes Starting');
	const { firebase } = useContext(FirebaseContext);
	const [furioosLink, setFurioosLink] = useState([]);
	const [matterportLink, setMatterportLink] = useState([]);
	const [show, setShow] = useState(false);
	const [files, setFiles] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showVM, setShowVM] = useState(false);
	const [currentVMData, setVMData] = useState({});
	const [floorplanImages, setFloorplanImages] = useState([]);
	const [openImage, setOpenImage] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);
	//const [vmAutoLoaded, setVmAutoLoaded] = useState(false);
	var currentUserId = firebase.auth().currentUser.uid;
	useEffect(async () => {
		await firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode)
			.once('value', async (snapshot) => {
				var furSnap = snapshot.child('glenridge');
				var furioosPresentations = [];

				let furLink;
				let vmAutoLoaded = false;
				var clientData = await getPreLoadedClientInfo();

				const sortByProperty = (property) => {
					return function (a, b) {
						if (a[property] < b[property]) return 1;
						else if (a[property] > b[property]) return -1;

						return 0;
					};
				};

				//get the list of presentations for furioos
				if (furSnap != null || furSnap !== undefined) {
					furSnap.forEach((element) => {
						var furioosId = element.val()?.id;
						var thisElevationId = element.val()?.elevationId;
						var thisUnitId = element.val()?.unitId;
						var furioosName = element.val()?.name;
						var furPose = element.key;
						const getImageLinkForFurioos = (callback) => {
							var imageRef = firebase
								.storage()
								.refFromURL(
									'gs://' +
										STORAGE_BUCKET.storageBucket +
										'.appspot.com/' +
										PROJECT_CODE.projectCode +
										'/' +
										furioosId +
										'.jpg'
								);

							imageRef
								.getDownloadURL()
								.then((url) => {
									callback(url);
								})
								.catch((error) => {
									console.log(error);
								});
						};

						getImageLinkForFurioos(async (imageLink) => {
							furLink = {
								id: furioosId,
								imageUrl: imageLink,
								name: furioosName,
								position: furPose,
								unitId: thisUnitId,
								elevationId: thisElevationId,
								show: true,
							};
							console.log('FUR POSE ' + furPose);
							furioosPresentations.push(furLink);
							// furioosPresentations.sort((a, b) =>{
							// 	return a.position < b.position;
							// });
							furioosPresentations.sort(
								sortByProperty('position')
							);
							console.log('Sorted fur Pose');

							console.log(
								'clientData ' + JSON.stringify(clientData)
							);
							if (clientData) {
								if (clientData['model'] !== furLink['unitId']) {
									furLink['show'] = false;
								} else if (
									clientData['option'] !==
									furLink['elevationId']
								) {
									furLink['show'] = false;
								}
							}
							if (furLink['show']) {
								if (vmAutoLoaded == false) {
									vmAutoLoaded = true;
									autoToVM(furLink);
								}
							}

							setFurioosLink([...furioosPresentations]);
						});
					});
				}
			});
		preCreateVMInstance();
	}, []);

	const preCreateVMInstance = () => {
		var formData = new FormData();

		formData.append('Test', 'test');
		fetch(
			'https://us-central1-aws-master-server.cloudfunctions.net/createGcpInstanceForUseOnRequest',
			{
				method: 'POST',
				body: formData,
				mode: 'no-cors',
			}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					console.log('Returned results ', JSON.stringify(result));
				},
				(error) => {
					console.error('ERROR response ', error);
				}
			)
			.catch((err) => {
				console.error(err.msg);
			});
	};

	const autoToVM = (firstVmInfo) => {
		const setVmInfo = firstVmInfo;
		setVMData(setVmInfo);
		setShowVM(true);
		setShow(true);
	};
	const handleAWS = (e) => {
		var thisId = e.currentTarget.dataset.id;
		var setVmInfo = {};
		furioosLink.forEach((vmInfo) => {
			if (vmInfo['id'] === thisId) {
				setVmInfo = vmInfo;
			}
		});
		//setVMData
		setVMData(setVmInfo);
		setShowVM(true);
		setShow(true);
	};

	const handleClose = () => {
		setShowVM(false);

		setShow(false);

		onUnityUpdateMessage.setFurioosOff();
	};

	const handleTwoDHomes = async (e) => {
		// setShowModal(true);

		var id = e.currentTarget.dataset.id;
		console.log(id);
		await getFloorplans(id, (returned) => {
			var imageArr = [];
			console.log('Floor plans', returned);

			returned.map((imageObj) => {
				imageArr.push(imageObj.href);
			});
			window.open(imageArr[0]);
		});

		setOpenImage(true);
	};

	const closeModalHandler = () => {
		setShowModal(false);
	};

	const useStyles = makeStyles({
		cardsGroup: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		root: {
			width: 400,
			margin: 10,
		},
		media: {
			height: 250,
		},
		cardArea: {
			pointerEvents: 'none',
		},
	});

	const getPreLoadedClientInfo = async () => {
		//edit this to redux

		console.log('getPreLoadedClientInfo');
		var userEmail;
		var userName;
		var preClientData;

		await firebase
			.database()
			.ref('users')
			.child(currentUserId)
			.once('value', (snapshot) => {
				userEmail = snapshot.val().email;
				userName = snapshot.val().displayName;
			});

		console.log(' WE MADE IT HERE !!1');

		await firebase
			.database()
			.ref('/kavtek_preload_client_info/' + PROJECT_CODE.projectCode)
			.once('value', (snapshot) => {
				var allData = snapshot.val();

				console.log(' WE MADE IT HERE !!2');

				allData.forEach((preClient) => {
					console.log('email pre load ' + preClient['email']);
					if (preClient['email'] === userEmail) {
						console.log('FOUND MATCHING USER');

						preClientData = preClient;
					} else if (preClient['purchaser'] === userName) {
						console.log('FOUND MATCHING USER Name');

						preClientData = preClient;
					}
				});
			});

		return preClientData;
	};

	const styles = useStyles();

	console.log('CURRENT ENTRY ' + JSON.stringify(currentVMData));

	useEffect(() => {
		console.log('showVMsdvewf', showVM);
	}, [showVM]);
	return (
		<>
			{/* {show && (
				<div className='cancelBtn' onClick={handleClose}>
					<CancelIcon className='cancelIcon' />
				</div>
			)} */}
			{/* {show && (
				<div id='furioosContainer_homes'>
					<div className='cancelBtn' onClick={handleClose}>
						<ClearIcon className='cancelIcon' />
					</div>
					<UnityController />
				</div>
			)} */}
			{showVM && (
				<div id='furioosContainer_homes'>
					{/* <div className='cancelBtn' onClick={handleClose}>
						<ClearIcon className='cancelIcon' />
					</div> */}

					<AWSController
						entryData={currentVMData}
						connectToHost={false}
						closeModalCallBack={handleClose}
					/>
				</div>
			)}
			<div className='threeDHomes-page'>
				<h2 id='three-title'>3D Virtual Tours</h2>
				{console.log('URLS IN MY PARTY: ' + files)}

				{!show && (
					<div className={styles.cardsGroup}>
						{furioosLink?.map((link) => {
							console.log('lisndfjwf', link);
							if (link['show'] === true) {
								return (
									<Card
										key={link.imageUrl}
										className={styles.root}
										data-id={link.id}
									>
										<CardActionArea
											className={styles.cardArea}
										>
											<CardMedia
												className={styles.media}
												image={link.imageUrl}
												title='Contemplative Reptile'
											/>
											<CardContent>
												<Typography
													gutterBottom
													variant='h5'
													component='h2'
												>
													{link.name}
												</Typography>
											</CardContent>
										</CardActionArea>
										<CardActions>
											<button
												className='btn btn-primary'
												data-id={link.id}
												onClick={handleAWS}
											>
												Start Structural Order
											</button>
											<button
												className='btn btn-primary'
												data-id={link.id}
												onClick={handleTwoDHomes}
											>
												Floorplans
											</button>
										</CardActions>
									</Card>
								);
							}
						})}
						{matterportLink?.map((link) => {
							return (
								<Card key={link.url} className={styles.root}>
									<CardActionArea className={styles.cardArea}>
										<CardMedia
											className={styles.media}
											image={link.imageUrl}
											title='Contemplative Reptile'
										/>
										<CardContent>
											<Typography
												gutterBottom
												variant='h5'
												component='h2'
											>
												{link.name}
											</Typography>
										</CardContent>
									</CardActionArea>
									<CardActions>
										<button
											className='btn btn-primary'
											onClick={() =>
												window.open(link.url)
											}
										>
											View 3D Model
										</button>
										<button
											className='btn btn-primary'
											data-id={link.id}
											onClick={handleTwoDHomes}
										>
											View 2D Model
										</button>
									</CardActions>
								</Card>
							);
						})}
					</div>
				)}

				{showModal === true && (
					<div
						className='back-drop'
						onClick={closeModalHandler}
					></div>
				)}
				<Modal
					show={showModal}
					close={closeModalHandler}
					title='2D Home View'
					buttonName='Close'
					button={closeModalHandler}
				>
					{files.length !== 0 ? (
						<Carousel
							autoPlay={false}
							showArrows={true}
							centerMode={false}
							swipeable={true}
							showStatus={false}
							emulateTouch={true}
							infiniteLoop={true}
							showThumbs={true}
						>
							{files?.map((image) => {
								return <img src={image} alt='' />;
							})}
						</Carousel>
					) : (
						<div>No content is being displayed at the moment.</div>
					)}
				</Modal>
				{/* <LotMatrix /> */}
			</div>

			{/* {openImage && (
				<Lightbox
					mainSrc={floorplanImages[photoIndex]}
					nextSrc={
						floorplanImages[
							(photoIndex + 1) % floorplanImages.length
						]
					}
					prevSrc={
						floorplanImages[
							(photoIndex + floorplanImages.length - 1) %
								floorplanImages.length
						]
					}
					onCloseRequest={() => {
						setOpenImage(false);
						setPhotoIndex(0);
						setFloorplanImages([]);
					}}
					onMovePrevRequest={() =>
						setPhotoIndex(
							(photoIndex + floorplanImages.length - 1) %
								floorplanImages.length
						)
					}
					onMoveNextRequest={() =>
						setPhotoIndex((photoIndex + 1) % floorplanImages.length)
					}
				/>
			)} */}
		</>
	);
}

export default ThreeDHomes;
